/**
 * Extracts the filename from a `content-disposition` response header,
 * falling back to the provided default when none is present.
 */
export function getContentDispositionFilename(
  headers: Record<string, string | undefined> | undefined,
  fallback: string,
): string {
  const contentDisposition = headers?.['content-disposition']
  if (contentDisposition) {
    const filenameMatch = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition)
    if (filenameMatch?.[1]) {
      return filenameMatch[1].replace(/['"]/g, '')
    }
  }
  return fallback
}

/**
 * Triggers a browser download for the given blob using a temporary anchor element.
 */
export function triggerFileDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
